// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"d8b3ab48","266":"9a1157af"}[chunkId] + ".chunk.css";
};